import { clearOnlineMeeting, onIsOnlineMeetingChanged } from 'owa-calendar-compose-form-actions';
import getQuickComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getQuickComposeViewState';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { hasAttendees } from 'owa-calendar-event-capabilities';
import { QUICK_COMPOSE_FORM_TYPE } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { orchestrator } from 'satcheljs';

/**
 * Clears the online meeting state for the element in quick compose if:
 * - there are no attendees
 * - the form type is quick compose
 * - the view type is Surface
 */
orchestrator(clearOnlineMeeting, actionMessage => {
    if (hasAttendees(actionMessage.event)) {
        return;
    }

    const openedForm = getComposeStore().openedForm;
    if (openedForm !== QUICK_COMPOSE_FORM_TYPE) {
        return;
    }

    const quickComposeViewState = getQuickComposeViewState();
    if (!quickComposeViewState || quickComposeViewState.viewType !== 'Surface') {
        return;
    }

    // Clear online meeting
    onIsOnlineMeetingChanged(
        false /* IsOnlineMeeting */,
        null /* onlineMeetingProvider */,
        false /* isOnlineMeetingExplicitlySet */,
        false /* wasOnlineMeetingEverAutoSet */
    );
});
